import axios from 'axios';
import {baseEnvironment} from '../environment/environment.base';
import { ResponseData,ConfigurationItem,updateResponseData } from './service-mappers/BaseMapper';
import {AnestheticGraphResponse, BPGraphResponse} from './types/AnestheticVitalsGraphTypes';

const v1Version = baseEnvironment.apiVersion1;

const vitalsRoute = `${v1Version}/${baseEnvironment.apiEndPoints.anestheticVitals.vitals}`;
const vitalsGraphRoute = `${v1Version}/${baseEnvironment.apiEndPoints.vitalsViews.graph}`;
const vitalsListRoute = `${v1Version}/${baseEnvironment.apiEndPoints.vitalsViews.list}`;
const vitalsUpdate = `${v1Version}/${baseEnvironment.apiEndPoints.anestheticVitals.updateVitals}`;
const to4Muscles = `${v1Version}/${baseEnvironment.apiEndPoints.To4Muscles.to4Muscles}`;

/* Find vitals information*/
export const getVitalsInformation = async (id: number): Promise<any> => {
  const response = await axios.get(`/${vitalsRoute}/${id}`);
  return response.data;
};

export const getVitalsInformationByTimeStamp = async (
  id: number,
  timeStamp: any
): Promise<any> => {
  const response = await axios.get(`/${vitalsRoute}/${id}/${timeStamp}`);
  return response.data;
};

export const createVitals = async (
  id: number,
  reqObject: any
): Promise<any> => {
  const response = await axios.post(`/${vitalsRoute}/${id}`, reqObject);
  return response.data;
};

export const updateSelectdVitalTimeStamp = async (
  id: number,
  timeStamp: any,
  vitalBody:any
): Promise<any> => {
  const response = await axios.post(`/${vitalsUpdate}/${id}/${timeStamp}`, vitalBody);
  return response.data;
};

export const getTo4Muscles = async (): Promise<ResponseData<ConfigurationItem[]>> => {
    const response = await axios.get(`/${to4Muscles}`);
    return response.data; // returning only the data from the response
};

export const updateTO4Muscles = async(changedList:any,deletedIds:any): Promise<updateResponseData> =>{
    const response = await axios.post(`/${to4Muscles}`,{changedList,deletedIds});
    return response.data;
}

export const getVitalsBPGraphInformation = async (id: number): Promise<BPGraphResponse> => {
  const response = await axios.get(`/${vitalsGraphRoute}/${id}/blood_pressure`);
  return response.data;
};

export const getAnestheticsGraphInformation = async (id: number): Promise<AnestheticGraphResponse> => {
  const response = await axios.get(`/${vitalsGraphRoute}/${id}/anesthetics`);
  return response.data;
};

export const getVitalsListInformation = async (id: number): Promise<any> => {
  const response = await axios.get(`/${vitalsListRoute}/${id}`);
  return response.data;
};